import Button from '@/components/Button/Button';
import useNotifications from '@/hooks/native/notifications/useNotifications';
import { FC, useCallback } from 'react';

const NotificationsTest: FC = () => {
	const {
		isNotificationPermissionGranted,
		requestNotificationPermission,
		scheduledNotifications,
		scheduleNotification,
	} = useNotifications();

	// Create a test notification in 5 seconds from now
	const createTestNotification = useCallback(() => {
		const date = new Date();
		date.setSeconds(date.getSeconds() + 5);
		scheduleNotification({
			id: 'test',
			date,
			title: 'Testnotificatie',
			description: 'Notificaties werken! 🥳',
		});
	}, [scheduleNotification]);

	return (
		<div className="grid justify-start gap-4">
			<p>
				Notificatietoestemming:{' '}
				{isNotificationPermissionGranted ? 'aan' : 'uit'}
			</p>
			{!isNotificationPermissionGranted && (
				<Button
					onClick={requestNotificationPermission}
					label="Vraag notificatietoestemming"
				/>
			)}
			<p>Geplande notificaties:</p>
			<code>{JSON.stringify(scheduledNotifications, null, 2)}</code>
			<Button
				onClick={createTestNotification}
				label="Test notificaties"
			/>
		</div>
	);
};

export default NotificationsTest;
